<template>
  <v-container grid-list-md>

    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-text-field name="title" required v-model="menu.title" label="Título"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-text-field name="to" v-model="menu.to" label="Link"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-text-field name="icon" v-model="menu.icon" label="Ícone"></v-text-field>
      </v-flex>
      <v-flex xs12 sm2>
        <v-text-field name="ordem" required v-model="menu.ordem" label="Ordem"></v-text-field>
      </v-flex>

      <v-flex xs12 sm6>
        <v-select
          required
          chips
          autocomplete
          label="Permissões"
          v-bind:items="itemsPermissoes"
          v-model="menu.permissoes"
          item-text="authority"
          item-value="id"
          multiple
          max-height="400"
          hint="Selecione as permissões"
          persistent-hint
        ></v-select>  
      </v-flex>
     
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-select
          chips
          autocomplete
          label="Menu Pai"
          v-bind:items="itemsMenu"
          v-model="menu.menuPai"
          item-text="title"
          item-value="id"          
          max-height="400"
          hint="Selecione o menu pai"
          persistent-hint
        ></v-select>  
      </v-flex>      
    </v-layout>

      <v-snackbar
        :timeout="timeoutAlerta"
        :color="tipoAlerta"
        v-model="snackbar">
        {{ textAlerta }}
        <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
      </v-snackbar>
    
  </v-container>

</template>

<script>
import axios from 'axios'

export default {
  name: 'menu-form',
  props: {
    menu: {}
  },
  data () {
    return {
      mostrarSenha: true,
      itemsPermissoes: [],
      itemsMenu: [],
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    }
  },
  components: {
  },
  methods: {
    pupularPermissoes () {
      var self = this
      axios.get('/permissoes')
      .then(response => {
        self.itemsPermissoes = response.data.list
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao carregar permissões'
        self.snackbar = true
      })
    },
    pupularMenu () {
      var self = this
      axios.get('/menus?semFilhos=s')
      .then(response => {
        self.itemsMenu = response.data.list
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao carregar menu'
        self.snackbar = true
      })
    }
  },
  created () {
    this.pupularPermissoes()
    this.pupularMenu()
  }
}
</script>

<style scoped>

  input[type=file] {
      position: absolute;
      left: -99999px;
  }
</style>



// WEBPACK FOOTER //
// MenuForm.vue?3cd0b8d2